import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { navigate } from 'gatsby';
import DefaultTitle from '../../components/DefaultTitle';
import DefaultParagraph from '../../components/DefaultParagraph';
import SvgHowCanWeHelp from '../../components/fromSvg/SvgHowCanWeHelp';
import DefaultContainer from '../../components/DefaultContainer';
import Button from '../../components/Button';


const StyledDefaultText = styled(DefaultParagraph)`
  text-align: left;
  max-width: 800px
`;

const TitleWithTopMargin = styled(DefaultTitle)`
  margin-top: 30px;
`;

const ButtonWithMargin = styled(Button)`
  margin-top: 30px;
`;

const HowCanWeHelp = () => {
  const theme = useContext(ThemeContext);

  return (
    <DefaultContainer backgroundColor={theme.colors.dark}>
      <SvgHowCanWeHelp />
      <TitleWithTopMargin>
        <span>Jak możemy pomóc?</span>
      </TitleWithTopMargin>
      <StyledDefaultText color={theme.colors.white}>
        Wysłuchamy Twoich oczekiwań i przekujemy je w plan działania.W naszej karierze
        remontowaliśmy setki pomieszczeń – wiemy jakie materiały i rozwiązania są
        najbardziej oszczędne, trwałe i solidne.
      </StyledDefaultText>
      <StyledDefaultText color={theme.colors.white}>
        Pracujemy zespołowo – każdy z nas jest
        specjalistą w swojej dziedzinie. Często korzystamy z metody
        burzy mózgów, by wygenerować jak najwięcej pomysłów na realizację planu.
      </StyledDefaultText>
      <StyledDefaultText color={theme.colors.white}>
        Na Twoje życzenie przeprowadzimy generalne sprzątanie po całym remoncie,
        posegregujemy śmieci, sprzątniemy pył i usuniemy gruz.
        Klienci cenią nas za kreatywność i konkrety.
      </StyledDefaultText>
      <ButtonWithMargin onClick={() => navigate('/ile-to-kosztuje')}>
        ile to kosztuje?
      </ButtonWithMargin>
    </DefaultContainer>
  );
};

export default HowCanWeHelp;
